import { request } from '../http'

interface AdventProduct {
  bdate?: string
  /**
   * 域名
   */
  domainName?: string
  edate?: string
  /**
   * 产品类别
   */
  productClass?: string
  /**
   * 产品ID
   */
  productID?: string
  /**
   * 产品名称
   */
  productName?: string
  /**
   * 用户名
   */
  username?: string
  [property: string]: any
}

/** 按到期日期分组的产品列表项 */
interface AdventProductGroupByDate {
  /**
   * 到期日期 YYYY-MM-DD
   */
  date?: string
  /**
   * 当天到期的产品列表
   */
  productList?: AdventProduct[]
}

/**
 *  公告列表
 */
export function getNoticeList(data: Search.Common) {
  const methodInstance = request.Post<Service.ResponseResult<User.Premessage.Notice.Info>>('/user/premessage/getNoticeList', data)
  return methodInstance
}

/**
 *  获取统计信息
 */
export function getProductStats() {
  const methodInstance = request.Get<Service.ResponseResult<User.Groupstation.ProductOverview.ProductStats.Info>>('/user/groupstation/productOverview/getProductStats')
  return methodInstance
}

/**
 *  获取统计信息的最近一条记录的产品类型
 */
export function getProductStatsLastProductType() {
  const methodInstance = request.Get<Service.ResponseResult<User.Groupstation.ProductOverview.ProductStats.Info>>('/user/groupstation/productOverview/getProductStatsLastProductType')
  return methodInstance
}

/**
 *  事项列表查询
 */
export function getInformqListSimple(params: { size: number }) {
  const methodInstance = request.Get<Service.ResponseResult<User.Premessage.InformqList.Info[]>>('/user/premessage/getInformqListSimple', { params })
  return methodInstance
}

/**
 *  工单列表
 */
export function getLastListSimple(params?: { dataNumber: number }) {
  const methodInstance = request.Get<Service.ResponseResult<User.Question.LastListSimple[]>>('/user/question/getLastListSimple', { params })
  return methodInstance
}

/**
 *  客服顾问信息
 */
export function getInputAndLeaderInfoSameple() {
  const methodInstance = request.Get<Service.ResponseResult<User.Membercenter.LastListSimple>>('/user/membercenter/getInputAndLeaderInfoSameple')
  return methodInstance
}

/**
 *  临近到期产品
 */
export function getAdventProduct() {
  const methodInstance = request.Get<Service.ResponseResult<AdventProduct>>('/user/usermembershipcenter/product/getAdventProduct')
  return methodInstance
}

/**
 * 查询所有未到期产品，按到期日期分组
 */
export function getAdventProductGroupByDate() {
  const methodInstance = request.Get<Service.ResponseResult<AdventProductGroupByDate[]>>('/user/usermembershipcenter/product/getAdventProductGroupByDate')
  return methodInstance
}

/**
 *  设置 是否开启操作校验-目前仅域名操作使用,0开启,1关闭
 */
export function setVerifyStatus(params: number) {
  const methodInstance = request.Get<Service.ResponseResult<User.Question.LastListSimple[]>>(`/user/membercenter/setVerifyStatus?verifyStatus=${params}`)
  return methodInstance
}

/**
 *  查询需要实名产品的数量
 */
export function needRealnameProduct() {
  const methodInstance = request.Get<Service.ResponseResult<any>>(`/user/realname/needRealnameProduct`)
  return methodInstance
}
